import script from "./GradesView.vue?vue&type=script&setup=true&lang=js"
export * from "./GradesView.vue?vue&type=script&setup=true&lang=js"

import "./GradesView.vue?vue&type=style&index=0&id=32fd816f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32fd816f"]])

export default __exports__